import { apiFetch, withToken } from "./http";

export type SupportAttachment = {
  id: number;
  file_name: string;
  size_bytes: number;
  mime: string;
  created_at: string;
};

export type SupportMessage = {
  id: number;
  ticket_id: number;
  author_id: number;
  author_role: "client" | "superadmin";
  author_name?: string;
  body: string;
  created_at: string;
  attachments?: SupportAttachment[];
};

export type SupportTicket = {
  id: number;
  org_id: number;
  created_by: number;
  creator_name?: string;
  creator_email?: string;
  subject: string;
  status: "open" | "answered" | "closed";
  priority: "low" | "normal" | "high";
  created_at: string;
  updated_at: string;
  message_count?: number;
  last_author_role?: "client" | "superadmin" | "";
  messages?: SupportMessage[];
};

async function jsonOrThrow<T>(res: Response, fallback: string): Promise<T> {
  if (!res.ok) {
    let msg = `${fallback} (HTTP ${res.status})`;
    try { const j = await res.json(); if (j?.error) msg = j.error; } catch { /* ignore */ }
    throw new Error(msg);
  }
  return res.json();
}

export async function listTickets(): Promise<SupportTicket[]> {
  const res = await apiFetch("/api/v1/support/tickets");
  const data = await jsonOrThrow<{ tickets: SupportTicket[] | null }>(res, "Talepler alınamadı");
  return data.tickets ?? [];
}

export async function getTicket(id: number): Promise<SupportTicket> {
  const res = await apiFetch(`/api/v1/support/tickets/${id}`);
  return jsonOrThrow<SupportTicket>(res, "Talep alınamadı");
}

export async function createTicket(input: { subject: string; body: string; priority: string; files: File[] }): Promise<SupportTicket> {
  const fd = new FormData();
  fd.append("subject", input.subject);
  fd.append("body", input.body);
  fd.append("priority", input.priority);
  input.files.forEach((f) => fd.append("files", f));
  const res = await apiFetch("/api/v1/support/tickets", { method: "POST", body: fd });
  return jsonOrThrow<SupportTicket>(res, "Talep oluşturulamadı");
}

export async function replyTicket(id: number, body: string, files: File[]): Promise<SupportTicket> {
  const fd = new FormData();
  fd.append("body", body);
  files.forEach((f) => fd.append("files", f));
  const res = await apiFetch(`/api/v1/support/tickets/${id}/messages`, { method: "POST", body: fd });
  return jsonOrThrow<SupportTicket>(res, "Mesaj gönderilemedi");
}

export async function setTicketStatus(id: number, status: "open" | "closed"): Promise<SupportTicket> {
  const res = await apiFetch(`/api/v1/support/tickets/${id}`, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ status }),
  });
  return jsonOrThrow<SupportTicket>(res, "Talep güncellenemedi");
}

export function attachmentURL(id: number): string {
  return withToken(`/api/v1/support/attachments/${id}`);
}

// SSE canlı bildirim akışı (EventSource header gönderemez → token query param).
export function eventsURL(): string {
  return withToken("/api/v1/support/events");
}
